import React from 'react';

import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import styles from './labs-feature-table.module.less';
import { messages } from '../../messages';
import { LabsFeatureTableRow } from '../feature-table-row/labs-feature-table-row';

/**
 * Labs feature table component
 * @param {object} props - Component props
 * @param {import('../../typedefs').LabsFeature[]} props.features - Array of features to display
 * @param {Set<string>} props.enabledFeatures - Set of enabled feature IDs
 * @param {boolean} [props.isLoading] - Whether initial features are loading
 * @param {(feature: import('../../typedefs').LabsFeature, isEnabled: boolean) => void} props.onToggle - Function called when user toggles feature
 * @param {(feature: import('../../typedefs').LabsFeature) => void} props.onSendFeedback - Function called when user wants to send feedback
 * @param {(feature: import('../../typedefs').LabsFeature) => void} props.onViewDetails - Function called when user wants to view feature details
 * @returns {React.ReactElement} The feature table component
 */
export const LabsFeatureTable = ({ features, enabledFeatures, isLoading = false, onToggle, onSendFeedback, onViewDetails }) => {
  return (
    <div className={styles['table-container']}>
      <div className={styles['table-header']}>
        <FlexRow className={styles['header-cell-name']}>
          <Text textType={TextType.Label} value={messages.feature} />
        </FlexRow>
        <FlexRow className={styles['header-cell-category']}>
          <Text textType={TextType.Label} value={messages.category} />
        </FlexRow>
        <FlexRow className={styles['header-cell-status']}>
          <Text textType={TextType.Label} value={messages.statusIndicator} />
        </FlexRow>
        <FlexRow className={styles['header-cell-actions']} />
      </div>

      {!isLoading &&
        features.map((feature) => (
          <LabsFeatureTableRow
            key={feature.id}
            feature={feature}
            isEnabled={enabledFeatures.has(feature.id)}
            onSendFeedback={onSendFeedback}
            onToggle={onToggle}
            onViewDetails={onViewDetails}
          />
        ))}
    </div>
  );
};
